import { useValidateListOrder } from '../../filter';
import { useAddOnListOrder } from './useAddOnListOrder';
import { useSetAddOnListOrder } from './useSetAddOnListOrder';

export const useValidateAddOnListOrder = () => {
  return useValidateListOrder(useAddOnListOrder, useSetAddOnListOrder);
};
